import { type TranslationKeys } from "@/hooks/useTranslation/useTranslation"
import { QuestionnaireStatusErrorCode } from "@/types/questionnaire/models"

export const statusErrorCodeTranslationMap: Record<
  QuestionnaireStatusErrorCode,
  TranslationKeys
> = {
  [QuestionnaireStatusErrorCode.Timeout]:
    "QUESTIONNAIRE_QUESTIONS/STATUS_ERROR/TIMEOUT",
  [QuestionnaireStatusErrorCode.FileTooLarge]:
    "QUESTIONNAIRE_QUESTIONS/STATUS_ERROR/FILE_TOO_LARGE",
  [QuestionnaireStatusErrorCode.UnsupportedFormat]:
    "QUESTIONNAIRE_QUESTIONS/STATUS_ERROR/UNSUPPORTED_FORMAT",
  [QuestionnaireStatusErrorCode.ParseError]:
    "QUESTIONNAIRE_QUESTIONS/STATUS_ERROR/PARSE_ERROR",
  [QuestionnaireStatusErrorCode.LlmError]:
    "QUESTIONNAIRE_QUESTIONS/STATUS_ERROR/LLM_ERROR",
  [QuestionnaireStatusErrorCode.AzureDiError]:
    "QUESTIONNAIRE_QUESTIONS/STATUS_ERROR/AZURE_DI_ERROR",
  [QuestionnaireStatusErrorCode.VlmError]:
    "QUESTIONNAIRE_QUESTIONS/STATUS_ERROR/VLM_ERROR",
  [QuestionnaireStatusErrorCode.UploadError]:
    "QUESTIONNAIRE_QUESTIONS/STATUS_ERROR/UPLOAD_ERROR",
  [QuestionnaireStatusErrorCode.ValidationError]:
    "QUESTIONNAIRE_QUESTIONS/STATUS_ERROR/VALIDATION_ERROR",
  [QuestionnaireStatusErrorCode.InternalError]:
    "QUESTIONNAIRE_QUESTIONS/STATUS_ERROR/INTERNAL_ERROR",
}
